import { MeldingClass } from '@/domain/interface/melding/MeldingClass';
import { Gebouw } from '@/domain/interface/melding/Gebouw';

class GebouwRequestDto {
  vbrAdresId?: string;
  vbrGebouwId?: string;
  vbrGebouwOnbestaand?: boolean;
  vbrGebouweenheidId?: string;
  vbrGebouweenheidOnbestaand?: boolean;

  straat?: string;
  nummer?: string;
  bus?: string;
  postcode?: string;
  gemeente?: string;

  constructor(gebouw: Gebouw) {
    this.vbrAdresId = gebouw.vbrAdresId;
    this.vbrGebouwOnbestaand = gebouw.isVbrGebouwOnbestaand();
    if (!this.vbrGebouwOnbestaand) {
      this.vbrGebouwId = gebouw.vbrGebouwId;
      this.vbrGebouweenheidOnbestaand = gebouw.isVbrGebouweenheidOnbestaand();
      if (!this.vbrGebouweenheidOnbestaand) {
        this.vbrGebouweenheidId = gebouw.vbrGebouweenheidId;
      }
    } else {
      this.vbrGebouweenheidOnbestaand = true;
    }
    this.straat = gebouw?.straat;
    this.nummer = gebouw?.nummer;
    this.bus = gebouw?.bus;
    this.postcode = gebouw?.postcode;
    this.gemeente = gebouw?.gemeente;
  }
}

export class MeldingRequestDto {
  id?: string;
  meldingsnummer?: string;
  gebouw?: GebouwRequestDto;
  zelfingegevenAdres: boolean;
  telefoonnummer: string;
  email: string;

  constructor(melding: MeldingClass) {
    this.id = melding.id === '' ? undefined : melding.id;
    this.meldingsnummer = melding.meldingsnummer;
    this.gebouw = new GebouwRequestDto(melding.gebouw);
    this.zelfingegevenAdres = melding?.zelfingegevenAdres;
    this.telefoonnummer = melding?.telefoonnummer;
    this.email = melding?.email;
  }
}
